module.exports = __webpack_public_path__ + "assets/media/logo.44134f08.svg";